const $ = jQuery;

export default class CommonRoute {
  constructor() {
    this.addEvents();
    this.modifyDOM();
  }

  addEvents() {
  }

  modifyDOM() {
    /*
	 * Header scroll magic
	 */
	var headerHeight, topHeaderHeight, didScroll, delta = 10, lastScrollTop = 10;

	function setHeaderVars() {
		headerHeight = parseInt( $('#mainHeader').outerHeight() );
		topHeaderHeight = parseInt( $('#topInnerHeader').outerHeight() );
	}

	setHeaderVars();
	$(window).resize(setHeaderVars);


	$(window).scroll(function(event){
		didScroll = true;
	});

	setInterval(function() {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}
	}, 250);

	function hasScrolled() {

		var st = $(window).scrollTop();

		// Make sure they scroll more than delta
		if(Math.abs(lastScrollTop - st) <= delta)
			return;

		// If they scrolled down and are past the navbar, add class .nav-up.
		if (st > lastScrollTop && ( st > (headerHeight / 2) ) ){

			// Scroll Down
			if ( $('#mainHeader').hasClass('activeTopMenu') || $('#mainSearch').hasClass('active')  ) {
				// Do nothing...
			} else {
				$('#mainHeader').addClass('min').css('top', '-'+topHeaderHeight+'px');
			}

		} else {
			// Scroll Up
			if(st + $(window).height() < $(document).height()) {

				if ( $('#mainNav').hasClass('active')  ) {
					// Do nothing...
				} else {

					$('#mainHeader').css('top', '0');

					if ( st < (headerHeight / 2) ) {
						$('#mainHeader').removeClass('min');
					}
				}
			}
		}

		lastScrollTop = st;

	};

	/*
	 * Top menu responsive toggle
	 */
	$('#topMenuToggle').click( function(e) {

		e.preventDefault();
//		$('body').toggleClass('fixedBody');
		$('.topNav ul').slideToggle();
		$(this).toggleClass('active');
		$('#mainHeader').toggleClass('activeTopMenu');

	});

	/*
	 * Megamenu scrollbar
	 */
  	$('li.hasSubMenu .subMenu').mCustomScrollbar({
		theme: 'kgk'
	});

	/*
	 * Main menu responsive toggle
	 */
	$('#mainMenuToggle').click( function(e) {

		e.preventDefault();
		$(this).toggleClass('active');
		$('#mainNav').toggleClass('active');
		$('#mainHeader').toggleClass('activeMainMenu');

	});

	/*
	 * Search toggle
	 */
	$('.searchLink a').click(function(e) {

		e.preventDefault();

		$('#mainSearch').toggleClass('active');

		if ( $('#mainHeader').hasClass('activeTopMenu') ) {
			$('.topNav ul').slideToggle();
			$('#mainHeader').removeClass('activeTopMenu');
		}
	});

	$('.closeSearch').click(function(e) {
		$('#mainSearch').toggleClass('active');
	});

	/*
	 * Product image carousel
	 */
	$('#productCarousel').owlCarousel({
		loop: true,
		margin: 20,
		autoplay : 5000,
		nav: true,
		navText: ['<i class="fa fa-chevron-left">', '<i class="fa fa-chevron-right">'],
		dots: false,
		responsive:{
			0:{
				items:1,
				nav: false,
			},
			400:{
				items:2,
				nav: false,
			},
			767:{
				items:3,
				nav: false,
			},
			992:{
				nav: true,
			}
		}
	});

	/*
	 * Initialize fancybox
	 */
	$('.fancybox').fancybox();

	/*
	 * Accordion toggle js
	 */
	$('.accordion .accordionToggle, .accordion .title').click( function() {

		$(this).closest('.accordion').toggleClass('active').find('.content').slideToggle();
	});

	/*
	 * Product page img/color picker
	 */
	$('.colorItems .color').click( function(e){
		var targetItem = $(this).attr('data-img-target'),
			imgID = '#colorPickImg';

		$('.color.active').removeClass('active');
		$(this).addClass('active');
		$('.productImg').find('.active').removeClass('active');
		$('.productImg').find(imgID+targetItem).addClass('active');
	});

	/*
	 * Mediacenter download matchheight
	 */
	$('.page-template-mediacenter .infoAccordions .files li').matchHeight();

	/*
	 * Product archive matchheight
	 */
	$('.post-type-archive-products .categoryGroup .productItem').matchHeight();
	$('.tax-product_category .categoryGroup .productItem').matchHeight();
  }
}
